import { render, staticRenderFns } from "./Dyte.vue?vue&type=template&id=10288cf7&"
import script from "./Dyte.vue?vue&type=script&lang=js&"
export * from "./Dyte.vue?vue&type=script&lang=js&"
import style0 from "./Dyte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10288cf7')) {
      api.createRecord('10288cf7', component.options)
    } else {
      api.reload('10288cf7', component.options)
    }
    module.hot.accept("./Dyte.vue?vue&type=template&id=10288cf7&", function () {
      api.rerender('10288cf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/bubble/integrations/Dyte.vue"
export default component.exports